import { Box } from '@material-ui/core';
import { formatMoney, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { ProcessingStrategyButton } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ProcessingStrategy/ProcessingStrategyButton';
import { CreditLinePaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CreditLine/_shared/entities/PaymentMethodDetail/CreditLinePaymentMethodDetailEntity';
import { CustomSkeleton } from '@/components/shared/components/CustomSkeleton';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useScreen } from '@/hooks/useScreen';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

interface ConditionsProps {
  paymentMethodDetailEntity: CreditLinePaymentMethodDetailEntity;
}

export const Conditions = ({ paymentMethodDetailEntity }: ConditionsProps) => {
  const { sm } = useScreen();
  const { getTextIdTranslation } = useTranslation();

  const loanPrincipal = paymentMethodDetailEntity.loan?.loanConditions.principal;
  const paymentMethod = paymentMethodDetailEntity.paymentMethod;

  const totalAmount = loanPrincipal
    ? formatMoney(amountToValueMoneyMapper(loanPrincipal))
    : paymentMethod?.amount != null
    ? formatMoney({ value: paymentMethod.amount, currency: paymentMethod.currency })
    : '';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gridGap: sm ? 12 : 8,
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: sm ? 'row' : 'column-reverse',
          justifyContent: sm ? 'space-between' : 'flex-start',
          alignItems: 'flex-start',
          gridGap: sm ? 16 : 8,
          width: '100%',
        }}
      >
        <FlexColumn>
          <Font variant="h2" color="title" style={{ wordBreak: 'break-all' }}>
            {getTextIdTranslation(PaymentMethodType.CREDIT_LINE)}
          </Font>
          {totalAmount && (
            <Box minWidth={60} maxWidth={120}>
              <Font variant="body2" color="textSecondary" display="block">
                <Text tId="AMOUNT" />
              </Font>
              <Font variant="subtitle1">{totalAmount}</Font>
            </Box>
          )}
        </FlexColumn>

        {paymentMethodDetailEntity.paymentMethod ? (
          <ProcessingStrategyButton paymentMethodDetailEntity={paymentMethodDetailEntity} />
        ) : (
          <Box minWidth={80}>
            <CustomSkeleton height={24} />
          </Box>
        )}
      </div>
    </div>
  );
};
